export default {
  reservations: [],
  pageCount: 0,
  data: null,
}
